import { type OperationVariables, type QueryHookOptions, useQuery } from '@apollo/client';
import { buildSharedSuperView, buildSuperView } from 'src/dynamoQueries/superView';

export function useSuperView<TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  type: string,
  useQueryArgs?: QueryHookOptions<TData, TVariables>,
) {
  const query = type !== 'shared' ? buildSuperView() : buildSharedSuperView();
  return useQuery<TData, TVariables>(query, useQueryArgs);
}
